import { render, staticRenderFns } from "./pos-change-product-mandate-modal.vue?vue&type=template&id=b641b7aa&scoped=true&"
import script from "./pos-change-product-mandate-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-change-product-mandate-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b641b7aa",
  null
  
)

export default component.exports